import { View } from 'foundations-components/components/View';
import SuiteFeatureTableBadge from 'pricing-pages-lib/components/SuiteFeatureTableBadge';
import { useSelector } from 'react-redux';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { useAppSelector } from '../../../reducers';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { getIsLatestVersionOfCrmSuiteInProductInventoryPreSeatsAndSeatsOnlySelector, getIsLatestVersionOfProductInProductInventorySelector, productsFromProductInventorySelector } from '../../../selectors/ProductInventorySelectors';
import { getTBSuiteProductForProductLevelSelector } from '../../../selectors/ProductsSelectors';
import CurrentPlanTag from './CurrentPlanTag';

/**
 * @description
 * This component is responsible for rendering only one badge at a time as we don't want to show multiple badges at once. This is similar to our BannerHierarchy component.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const SuiteBadge = ({
  productLevel
}) => {
  const isAppReady = useGlobalLoading();
  const ownedProducts = useAppSelector(state => {
    if (!isAppReady) return [];
    return productsFromProductInventorySelector(state);
  });
  const isFreePortal = ownedProducts && ownedProducts.length <= 0;
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const isCurrentPlanLevel = useSelector(state => {
    if (!isAppReady) {
      return false;
    }
    const suiteProduct = getTBSuiteProductForProductLevelSelector(state, {
      suiteProductLevel: productLevel
    });
    if (suiteProduct) {
      return getIsLatestVersionOfProductInProductInventorySelector(state, {
        productIdentifier: {
          apiName: suiteProduct === null || suiteProduct === void 0 ? void 0 : suiteProduct.apiName
        }
      });
    }
    return getIsLatestVersionOfCrmSuiteInProductInventoryPreSeatsAndSeatsOnlySelector(state, productLevel);
  });
  const showRecommendedBadge = isAppReady && isFreePortal && productLevel === STARTER;
  if (isCurrentPlanLevel) {
    return /*#__PURE__*/_jsx(CurrentPlanTag, {});
  }
  if (showRecommendedBadge) {
    return /*#__PURE__*/_jsx(View, {
      position: "absolute",
      insetBlockStart: "200",
      insetInlineEnd: "200",
      children: /*#__PURE__*/_jsx(SuiteFeatureTableBadge, {
        translationKey: isAppAuth ? 'recommended' : 'mostPopular'
      })
    });
  }
  return null;
};